import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import LocalizationPanel, { LocalizationChangeHandler } from './LocalizationContainer';
import { TargetNode } from '../../models/TargetNode';


type ChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => void;

interface ThankYouPanelOwnProps {
  node: TargetNode;
  // Whether the thank-you page is switched on (extra.c.c49).
  enabled: boolean;
  onToggleEnabled: ChangeHandler;
  thankyouText: string;
  onChangeThankyou: ChangeHandler;
  thankyouLocalizationChanged: LocalizationChangeHandler;
  // The four hidden extras below are ordinary extra.k presence toggles.
  extraKIds: Set<string>;
  onChangeExtra: ChangeHandler;
}

// Rendered inside a permanently `hidden` block — see the note at the usage site.
const HIDDEN_EXTRAS = [
  { label: 'Do not show results', name: 'contactFormDoNotShowResults', redisid: 'dontshowresults' },
  { label: 'Enable public monitor', name: 'contactFormPublicMonitor', redisid: 'publicmonitor' },
  { label: 'Show description text on target', name: 'contactFormShowDescOnTarget', redisid: 'showdescription' },
  { label: 'Enable image upload', name: 'contactFormEnableImageUpload', redisid: 'imageupload' },
];

const ThankYouPanel = ({
  node, enabled, onToggleEnabled,
  thankyouText, onChangeThankyou, thankyouLocalizationChanged,
  extraKIds, onChangeExtra, t,
}: ThankYouPanelOwnProps & WithTranslation) => (
  <fieldset>
    <legend>{t('target.editor.label.thankYouPage')}</legend>
    <label>{t('target.editor.label.enable')}</label>
    <input type="checkbox" data-redisid="showoptionalthanks"
      title="Enable Optional Questions"
      checked={enabled}
      onChange={onToggleEnabled}
    />
    <div style={{ height: "0.2em" }}></div>
    <div className={!enabled ? "hidden" : ""}>
      <label>{t('target.editor.label.thanksText')}</label>
      <input type="text" name="contactFormThankYouText" data-redisid="thankYouText"
        value={thankyouText}
        onChange={onChangeThankyou} />
      <LocalizationPanel
        node={node}
        localizationChanged={thankyouLocalizationChanged}
        header={t('target.editor.button.addThankYouLocalisation')}
        localizationIndex={4}
      />
    </div>
    {/*
      These four are hard-coded `hidden` — not gated on any state, so they are
      unreachable in the UI. They are kept because they are still real extra.k
      fields: CONTACT_FIELDS lists all four, so whatever is already stored for
      them round-trips through save. Removing the markup would need a decision
      about whether the fields themselves are still wanted.
      Labels are literal, not i18n keys, exactly as before.
    */}
    <label className="hidden">Extra properties</label>
    <div className="hidden">
      {HIDDEN_EXTRAS.map(({ label, name, redisid }) => (
        <div key={redisid}>
          <label>{label}</label>
          <input type="checkbox" name={name}
            data-redisid={redisid}
            checked={extraKIds.has(redisid)}
            onChange={onChangeExtra} />
        </div>
      ))}
    </div>
  </fieldset>
);

export default withTranslation('common')(ThankYouPanel);
